/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  EntityId,
  List,
  MemberRole,
  UserSitePermission,
  UserSitePermissionOverride,
} from "./data-contracts";

/**
 * No description
 * @tags site-users
 * @name ListPermissionsAggregateInSite
 * @summary List all sites users permissions
 * @request GET:/orgs/{organizationId}/sites/{siteId}/permissions/aggregate
 * @secure
 */

// @ts-ignore
export const listPermissionsAggregateInSite: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /**
     * An order for the items in the list
     * @default "desc"
     */
    order?: "asc" | "desc";
    /** The role to filter the list by */
    role?: MemberRole | "guest";
    /** A query to filter the list by display name and email */
    search?: string;
    /**
     * The property to sort the list by
     * @default "joinedAt"
     */
    sort?: "joinedAt" | "lastSeenAt" | "name";
    /** Team identifier. Filter the list to members of a specific team. */
    team?: string;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    /**
     * Number of users with a role in the site, guests excluded. It ignores the filters and the pagination of the request.
     * @min 0
     */
    membersCount: number;
    items: UserSitePermission[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/permissions/aggregate",
  method: "get",
  streaming: false,
  tags: ["site-users"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-users
 * @name ListUserPermissionsInSite
 * @summary List site user permissions
 * @request GET:/orgs/{organizationId}/sites/{siteId}/permissions/users
 * @secure
 */

// @ts-ignore
export const listUserPermissionsInSite: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: UserSitePermissionOverride[];
  };
  ResponseStatusCode: 200 | 404;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/permissions/users",
  method: "get",
  streaming: false,
  tags: ["site-users"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-users
 * @name UpdateUserPermissionInSite
 * @summary Update site user permissions
 * @request PATCH:/orgs/{organizationId}/sites/{siteId}/permissions/users/{userId}
 * @secure
 */

// @ts-ignore
export const updateUserPermissionInSite: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /**
     * "The role of a member in an organization.
     * "admin": Can administrate the content: create, delete spaces, ...
     * "create": Can create content.
     * "review": Can review content.
     * "edit": Can edit the content (live or change requests).
     * "comment": Can access the content and its discussions.
     * "read": Can access the content, but cannot update it in any way.
     */
    role?: MemberRole;
  };
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 404;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/permissions/users/{userId}",
  method: "patch",
  streaming: false,
  tags: ["site-users"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-users
 * @name RemoveUserFromSite
 * @summary Remove a site user
 * @request DELETE:/orgs/{organizationId}/sites/{siteId}/permissions/users/{userId}
 * @secure
 */

// @ts-ignore
export const removeUserFromSite: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/permissions/users/{userId}",
  method: "delete",
  streaming: false,
  tags: ["site-users"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
